import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addObjectType: {
		id: 'cmdb-schema-navigation.common.add-object-type',
		defaultMessage: 'Add object type',
		description: 'The label for a button, that when clicked will add an object type',
	},
});
